<template>
  <main class="page-orderSys-config page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <div class="top-btns">
        <el-button @click="$_modify(-1)" class="btn__add"
          >新增应用系统</el-button
        >
      </div>
      <el-form :inline="true" class="filter-form">
        <el-form-item label="系统名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              v-model="filter.systemName"
              :fetch-suggestions="$_handleSearchSystemName"
              :trigger-on-focus="false"
              value-key="systemName"
              @select="$_handleSelectSystemName"
            ></el-autocomplete>
            <div
              v-show="!searchSystemNameData.length && filter.systemName"
              @click="$_clearSearchSystemNameData"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该系统名称，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="应用ID:">
          <el-input
            v-model.number="filter.cid"
            style="width: 110px;"
          ></el-input>
        </el-form-item>

        <el-form-item label="父级应用:">
          <el-select v-model="filter.parentId" style="width: 110px;">
            <el-option
              v-for="systemApp in systemApplicationList"
              :key="systemApp.id"
              :label="systemApp.name"
              :value="systemApp.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="操作" width="380" :resizable="false">
          <template slot-scope="scope">
            <el-button
              class="edit__btn"
              @click="$_modify(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button class="edit__btn" @click="$_menu(scope.row)"
              >权限管理</el-button
            >
            <cd-switch
              v-model="scope.row.status"
              @input="$_switch(scope.$index, scope.row)"
              :true-value="1"
              :false-value="2"
            >
              <span slot="open">启用</span>
              <span slot="close">停用</span>
            </cd-switch>
            <el-button class="delete__btn" @click="$_delete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="系统Logo" width="160" :resizable="false">
          <template slot-scope="scope">
            <img
              class="delete__btn"
              :src="scope.row.systemLogo"
              style="width:46px;height:46px;object-fit:cover;margin-right:10px;"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          v-else
        >
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row"></component>
          </template>
        </el-table-column>
        <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getConfigs"
      ></cd-pagination>
    </div>

    <modal-modify
      v-if="modal.show && modal.template === 'modify'"
      :title="modal.title"
      :formType="modal.type"
      :systemApplicationList="systemApplicationList"
      :modalData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></modal-modify>

    <modal-permission
      v-if="modal.show && modal.template === 'permission'"
      :modalData="modal.data"
      @close="$_close"
    ></modal-permission>
  </main>
</template>

<script>
import * as Utils from "@/plugins/utils";
import resize from "@/mixins/resize";
import ModalModify from "./modal-modify";
import ModalPermission from "./permission/index";

const columns = [
  { key: "cid", label: "应用ID", width: 120 },
  { key: "sscId", label: "共享自增ID", width: 120 },
  { key: "appId", label: "appID", width: 140 },
  { key: "systemName", label: "系统名称", width: 120 },
  { key: "systemCode", label: "系统编码", width: 120 },
  { key: "parentAppName", label: "父级应用", width: 120 },
  { key: "systemUrl", label: "系统地址", width: 160 },
  { key: "memo", label: "备注", width: 160 },
  { key: "creator", label: "创建人", width: 120 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "operator", label: "最后编辑人", width: 120 },
  { key: "updateTime", label: "最后编辑时间", width: 160 },
];

export default {
  name: "account-new-app-configs",
  mixins: [resize],
  data() {
    return {
      isLoading: false,
      filter: {
        systemName: "", // 外卖平台编码
        cid: 0,
        cid: null,
        parentId: null,
      },
      searchSystemNameData: [],
      systemApplicationList: [],
      tableHeight: null,
      dataList: [],
      columns,
      curr: "",
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0,
      },
      modal: {
        show: false,
        title: "",
        template: "",
        type: "",
        data: {},
      },
    };
  },

  methods: {
    getSystemApplicationList() {
      this.$service.post("getSystemApplicationList").then((result) => {
        if (result.$.checkResult(result, true)) {
          this.systemApplicationList = result.data;
        }
      });
    },
    //菜单管理
    $_menu(row) {
      this.modal.data = row;
      this.modal.template = "permission";
      this.modal.show = true;
    },
    $_handleSearchSystemName(systemName, cb) {
      let postData = {
        systemName: systemName,
        pageNow: 1,
        pageSize: 9999,
      };
      this.$service.post("getNewAppSysConfigs", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.searchSystemNameData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    $_handleSelectSystemName(item) {
      this.filter.systemName = item.systemName;
      this.filter.cid = item.cid;
    },
    $_clearSearchSystemNameData() {
      this.filter.systemName = "";
      this.filter.cid = "";
    },
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      let reg = /[^\d.]/g;
      if(this.filter.cid && new RegExp(reg).test(this.filter.cid)){
         $MessageBox.alert({
          content: `
            <div>应用id需填数字！</div>
          `,
        });
      }else{
         this.$_getConfigs();
      }
    },
    // 重置
    $_reset() {
      this.filter.systemName = "";
      this.filter.cid = null;
      this.filter.parentId = null;
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getConfigs();
    },
    // 查询应用配置列表
    $_getConfigs() {
      this.isLoading = true;
      this.$refs.tableList.clearSort();
      const postData = {
        cid: 0,
        cid: this.filter.cid || null,
        parentId: this.filter.parentId,
        systemName: this.filter.systemName,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize,
      };
      this.$service.post("getNewAppSysConfigs", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getConfigs();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getConfigs();
    },
    // 更新品牌状态 - 1-启用/2-停用/3-删除
    $_delete(row) {
      const self = this;
      let content = "是否确认删除应用系统，若删除会将共享上同一个应用一并删除"
      let cidList = [row.cid];
      $MessageBox.confirm({
        content,
        onOk() {
          self.$service
            .post("updateNewAppSysConfigStatus", {
              cidList,
              status: 3,
            })
            .then((result) => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.$_getConfigs();
                  },
                });
              }
            });
        },
      });
    },
    //停启用
    $_switch($index, row, status) {
      status = status || row.status;
      const self = this;
      let cidList = [row.cid];
      const callback = (content) => {
        $MessageBox.alert({
          content,
          onOk() {
            self.$_getConfigs();
          },
        });
      };
      if (row.status === 1) {
        // 停用切换成启用
        self.$service
          .post("updateNewAppSysConfigStatus", {
            cidList,
            status: 1,
          })
          .then((result) => {
            if (result.$.checkResult(result, true)) {
              callback(result.msg);
            } else {
              self.dataList[$index].status = 1;
            }
          });
      } else if (row.status === 2) {
        // 启用切换成停用
        $MessageBox.confirm({
          content: `
            <div>是否停用当前系统？</div>
          `,
          onOk() {
            self.$service
              .post("updateNewAppSysConfigStatus", {
                cidList,
                status: 2,
              })
              .then((result) => {
                if (result.$.checkResult(result, true)) {
                  callback(result.msg);
                } else {
                  self.dataList[$index].status = 2;
                }
              });
          },
          onCancel() {
            if (status === 2) {
              self.dataList[$index].status = 1;
            }
          },
        });
      }
    },

    $_modify($index, row) {
      this.isLoading = true;
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "新增应用系统";
      if ($index !== -1) {
        this.modal.type = "edit";
        this.modal.title = "编辑应用系统";
        this.modal.data = JSON.parse(JSON.stringify(row));
      }
      this.modal.template = "modify";
      this.modal.show = true;
      this.isLoading = false;
    },

    // 新增/编辑配置成功回调
    $_callback() {
      this.$_close();
      this.$_getConfigs();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    },
  },

  components: {
    ModalModify,
    ModalPermission,
  },
  mounted() {
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    this.getSystemApplicationList();
    this.$_getConfigs();
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .top-btns {
    min-height: 40px;
  }

  .filter-form {
    .autocomplete-box {
      display: inline-block;
      position: relative;
      width: 110px;
      .autocomplete-empty {
        padding: 10px;
        margin: 0;
        color: #535353;
        width: 100%;
      }
    }
    .el-form-item {
      margin-top: 12px;
    }
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
  .sort-input {
    min-width: 50px;
    text-align: center;
    /deep/ .el-input__inner {
      text-align: center;
    }
  }
}
.el-table__body-wrapper .cd-switch {
  margin-left: 6px;
}
</style>
